import { Form, Input } from 'antd';
import { cn } from '@/libs/utils';
import { useCompanyGeneralDataForm } from '../CompanyGeneralDataFormContext';

/** API key, company name, registration numbers and market. */
export default function CompanyIdentityFields() {
  const {
    apiKeyKeys,
    apiKeyState,
    codeKeys,
    codeState,
    companyNameKeys,
    companyNameState,
    eInvoiceChecked,
    inSection,
    isProfile,
    pibKeys,
    pibState,
    sectionClass,
    t,
  } = useCompanyGeneralDataForm();

  return (
    <>
      {eInvoiceChecked && apiKeyState?.visible && (
        <Form.Item
          hidden={!inSection('efakture')}
          className={cn(isProfile && 'mt-5')}
          name={apiKeyKeys}
          // Kept preserved (antd's default) on purpose. Dropping the value
          // when e-invoicing is switched off would leave this required input
          // empty on switching back on, while the stored key is still there —
          // and the save would then fail validation on a credential nobody
          // removed. What the field shows and what the record holds now agree
          // because the server no longer erases the key; see
          // `preserveUnsentCompanyFields`.
          label={t('apiKey', { ns: 'forms' })}
          rules={[
            {
              required: true,
              message: t('formValidation.apiKeyRequired', { ns: 'forms' }),
            },
          ]}
        >
          <Input
            placeholder={t('apiKey', { ns: 'forms' })}
            disabled={apiKeyState?.disabled}
          />
        </Form.Item>
      )}

      {companyNameState?.visible && (
        <Form.Item
          hidden={!inSection('osnovno')}
          label={t('companyName', { ns: 'forms' })}
          name={companyNameKeys}
          rules={[
            {
              required: true,
              message: t('formValidation.companyNameRequired', {
                ns: 'forms',
              }),
            },
          ]}
        >
          <Input
            placeholder={t('companyName', { ns: 'forms' })}
            disabled={companyNameState?.disabled}
          />
        </Form.Item>
      )}

      <div className={cn('flex gap-x-5', sectionClass('osnovno'))}>
        {codeState?.visible && (
          <Form.Item
            label={t('registrationNumber', { ns: 'forms' })}
            name={codeKeys}
            className="w-full"
            rules={[
              {
                required: true,
                message: t('formValidation.numberField.invalid', {
                  ns: 'forms',
                }),
              },
            ]}
          >
            <Input
              type="number"
              placeholder={t('registrationNumber', { ns: 'forms' })}
              disabled={codeState?.disabled}
            />
          </Form.Item>
        )}

        {pibState?.visible && (
          <Form.Item
            name={pibKeys}
            className="w-full"
            label={t('tin', { ns: 'tables' })}
            rules={[
              {
                required: true,
                message: t('formValidation.pibRequired', { ns: 'forms' }),
              },
            ]}
          >
            <Input
              placeholder={t('tin', { ns: 'tables' })}
              disabled={pibState?.disabled}
            />
          </Form.Item>
        )}
      </div>
    </>
  );
}
